Vue.asyncComponent('cms-import', {
    props: {
        bundle: {
            type: String,
            required: false
        },
        importDefinition: {
            type: String,
            required: false
        },
    },
}, 'cms/pages/cms-import.html');